import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './app.jsx';
import { supabase } from './config/supabase.js';

// Row-level security grants lead access to the `authenticated` role only. When a
// Supabase session lapses the client quietly falls back to `anon`, and every
// query then returns zero rows with no error — indistinguishable from an empty
// CRM. Drop the cached profile so the app asks for a fresh sign-in instead.
const clearLocalSession = () => {
    try {
        localStorage.removeItem('crm_session');
        localStorage.removeItem('crm_user');
    } catch (e) { /* storage unavailable */ }
};

supabase.auth.onAuthStateChange((event, session) => {
    if (event === 'SIGNED_OUT' || (event === 'TOKEN_REFRESHED' && !session)) {
        clearLocalSession();
    }
});

// A stored profile with no Supabase session means the token expired while away.
supabase.auth.getSession().then(({ data }) => {
    if (!data?.session && localStorage.getItem('crm_session')) {
        clearLocalSession();
        window.location.reload();
    }
}).catch(() => { /* leave the app to handle it */ });

// Vite fires this when a hashed chunk from a previous deploy can no longer be
// fetched. Reload once so the tab picks up the current build instead of blanking.
window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault();
    if (!sessionStorage.getItem('crm_chunk_reload')) {
        sessionStorage.setItem('crm_chunk_reload', '1');
        window.location.reload();
    }
});

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
